import * as React from 'react';
import Svg, {ClipPath, Path, Defs, G} from 'react-native-svg';
import {shortcutIconColors} from 'src/components/elements/home/ShortcutButton';

const WalletShortcut = () => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
    <G clipPath="url(#clip0_23437_63679)">
      <Path
        d="M17.85 5.725l-.58-2.32a.915.915 0 00-1.128-.663L5.125 5.707"
        fill={shortcutIconColors().tertiaryColor ?? '#66A7FF'}
      />
      <Path
        d="M17.85 5.725l-.58-2.32a.915.915 0 00-1.128-.663L5.125 5.707"
        stroke={shortcutIconColors().strokeColor ?? '#E6ECFF'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.708 15.79v2.292A3.208 3.208 0 0117.5 21.29H3.29a1.833 1.833 0 01-1.833-1.833V7.54a1.833 1.833 0 011.833-1.833H17.5a3.208 3.208 0 013.208 3.208v2.292"
        fill={shortcutIconColors().primaryColor ?? '#0052BF'}
      />
      <Path
        d="M17.5 18.54H3.29a1.833 1.833 0 01-1.833-1.833v2.75a1.833 1.833 0 001.833 1.833H17.5a3.209 3.209 0 003.208-3.208v-2.75A3.208 3.208 0 0117.5 18.54z"
        fill={shortcutIconColors().secondaryColor ?? '#58C6BB'}
      />
      <Path
        d="M20.708 15.79v2.292A3.208 3.208 0 0117.5 21.29H3.29a1.833 1.833 0 01-1.833-1.833V7.54a1.833 1.833 0 011.833-1.833H17.5a3.208 3.208 0 013.208 3.208v2.292"
        stroke={shortcutIconColors().strokeColor ?? '#E6ECFF'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.208 13.04a1.833 1.833 0 011.833-1.833h3.667a1.834 1.834 0 011.833 1.833v.917a1.833 1.833 0 01-1.833 1.833h-3.667a1.833 1.833 0 01-1.833-1.833v-.917z"
        fill={shortcutIconColors().primaryColor ?? '#0052BF'}
      />
      <Path
        d="M20.708 13.499h-3.667a1.833 1.833 0 01-1.7-1.146 1.82 1.82 0 00-.133.688v.916a1.834 1.834 0 001.833 1.833h3.667a1.833 1.833 0 001.833-1.833v-.917c0-.235-.046-.469-.134-.687a1.832 1.832 0 01-1.699 1.146z"
        fill={shortcutIconColors().secondaryColor ?? '#58C6BB'}
      />
      <Path
        d="M15.208 13.04a1.833 1.833 0 011.833-1.833h3.667a1.834 1.834 0 011.833 1.833v.917a1.833 1.833 0 01-1.833 1.833h-3.667a1.833 1.833 0 01-1.833-1.833v-.917z"
        stroke={shortcutIconColors().strokeColor ?? '#E6ECFF'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17.62 13.728a.23.23 0 010-.458M17.621 13.728a.229.229 0 000-.458"
        stroke={shortcutIconColors().strokeColor ?? '#E6ECFF'}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_23437_63679">
        <Path fill="#fff" transform="translate(1 1)" d="M0 0H22V22H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default WalletShortcut;
